import { render, staticRenderFns } from "./RoundButton.vue?vue&type=template&id=c03f0ac2&"
import script from "./RoundButton.vue?vue&type=script&lang=js&"
export * from "./RoundButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports